<template>
  <div class="keypoint" @click="$emit('click')">
    <transition name="t-fader__enter-delay">
      <div v-if="!isSelected" class="keypoint__bullet"></div>
    </transition>
  </div>
</template>

<script>
import Object3d from '@/plugins/Dom3d/mixin'

export default {
  mixins: [Object3d],

  props: {
    isSelected: {
      type: Boolean,
      default: false
    }
  }
}

</script>

<style lang="stylus">
@import '~@/styles/settings/easings'
@import '~@/styles/settings/variables'

.keypoint
  width 40px
  height 40px
  cursor pointer
  pointer-events normal

  &__bullet
    background-color: $colors.white
    box-shadow 0 2px 8px rgba($colors.black, .5)
    height 50%
    width 50%
    margin: auto
    border-radius 50%
    position: relative
    pointer: cursor
    transition .3s

    &::before, &::after
      content ''
      position absolute
      top 50%
      left 50%
      border-radius 50%
      transform translate(-50%, -50%)
      border solid 3px #17dbc4
      animation: 2s ease-out-quart infinite pulse
      box-shadow 0 0 8px rgba(#fff, .4), inset 0 0 8px rgba(#fff, .4)
      transform translate(-50%, -50%)
      pointer-events none

    &::before
      width 320%
      height 320%
      animation-delay: -.1s

    &::after
      width 230%
      height 230%

  &:hover &__bullet
    background-color #17dbc4
    transform scale(1.4)
    transition .15s
    border 7px solid $colors.white

  &:hover &__bullet::before, &:hover &__bullet::after
    opacity 0
    animation: none
    transition .4s

@keyframes pulse
  from
    transform: translate3d(-50%, -50%, 0) scale(.52)
    opacity 1

  to
    transform: translate3d(-50%, -50%, 0) scale(1)
    opacity 0
</style>
